import React, { FunctionComponent } from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';

import { getRoutes } from '../routes/routes.util';

export const RoutesRenderer: FunctionComponent =
  (): React.ReactElement | null => {
    const routes: RouteObject[] = getRoutes();
    return useRoutes(routes);
  };
